
export function isEmpty(value){
    return value.trim().length === 0;
}

